module.exports = __webpack_public_path__ + "static/media/insta-native.bfbbc4c2.png";